var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWalletlogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 0C40.3609 0 52 11.6391 52 26C52 40.3609 40.3609 52 26 52C11.6391 52 0 40.3609 0 26C0 11.6391 11.6391 0 26 0Z",
    fill: "url(#paint0_radial_1017_25633)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5234 20.079C21.7539 14.9704 30.2445 14.9704 35.475 20.079L36.1047 20.6985C36.3688 20.9524 36.3688 21.3688 36.1047 21.6228L33.9516 23.7251C33.8195 23.8571 33.6063 23.8571 33.4742 23.7251L32.6109 22.8821C28.9547 19.3173 23.0437 19.3173 19.3875 22.8821L18.4633 23.786C18.3312 23.9181 18.118 23.9181 17.9859 23.786L15.8328 21.6837C15.5688 21.4298 15.5688 21.0134 15.8328 20.7595L16.5234 20.079ZM39.9336 24.4259L41.8531 26.2946C42.1172 26.5485 42.1172 26.9649 41.8531 27.2188L33.2102 35.6587C32.9461 35.9126 32.5195 35.9126 32.2656 35.6587L26.1312 29.6665C26.0703 29.6056 25.9586 29.6056 25.8977 29.6665L19.7633 35.6587C19.4992 35.9126 19.0727 35.9126 18.8187 35.6587L10.1453 27.2188C9.88125 26.9649 9.88125 26.5485 10.1453 26.2946L12.0648 24.4259C12.3289 24.172 12.7555 24.172 13.0094 24.4259L19.1438 30.4181C19.2047 30.479 19.3164 30.479 19.3773 30.4181L25.5117 24.4259C25.7758 24.172 26.2023 24.172 26.4563 24.4259L32.5906 30.4181C32.6516 30.479 32.7633 30.479 32.8242 30.4181L38.9586 24.4259C39.243 24.172 39.6695 24.172 39.9336 24.4259Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1017_25633",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.000161171 26.0008) scale(52)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletlogo);
export default __webpack_public_path__ + "static/media/walletlogo.dbee9704.svg";
export { ForwardRef as ReactComponent };